import script from "./Onboard.vue?vue&type=script&setup=true&lang=js"
export * from "./Onboard.vue?vue&type=script&setup=true&lang=js"

import "./Onboard.vue?vue&type=style&index=0&id=575988bc&scoped=true&lang=css"

import exportComponent from "/home/buddymetal/actions-runner/_work/candidate/candidate/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-575988bc"]])

export default __exports__